import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { WORKER_STATUS_UPDATED } from '../../actionTypes/backendStatus';

/**
 * Records what one worker is doing right now, from a heartbeat.
 */
var updateWorkerStatus = function updateWorkerStatus(experimentId, workerGpuType, workerStatus) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: WORKER_STATUS_UPDATED,
              payload: {
                experimentId: experimentId,
                workerGpuType: workerGpuType,
                workerStatus: workerStatus
              }
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateWorkerStatus;